<template>
  <div class="payment-page">
    <header class="payment-page__header">
      <h1 class="payment-page__title">{{ $t('banking.bank_info') }}</h1>
      <p class="payment-page__subtitle">
        {{ $store.state.language === 'en' ? 'Link your withdrawal bank account' : 'ငွေထုတ်ရန် ဘဏ်အကောင့် ချိတ်ဆက်ရန်' }}
      </p>
    </header>

    <section class="payment-panel">
      <div class="payment-panel__accent"></div>
      <div class="payment-panel__body">
        <div v-if="error" class="payment-error-banner">
          {{ error }}
        </div>

        <form @submit.prevent>
          <div class="payment-field">
            <label class="payment-field__label">{{ $t('banking.bank_username') }}</label>
            <input
              type="text"
              class="payment-input"
              v-model="account.name"
            />
            <span class="payment-field__error">{{ errors.name }}</span>
          </div>

          <div class="payment-field">
            <label class="payment-field__label">{{ $t('banking.bank_number') }}</label>
            <input
              type="number"
              class="payment-input"
              v-model="account.account_number"
            />
            <span class="payment-field__error">{{ errors.number }}</span>
          </div>

          <div class="payment-field">
            <label class="payment-field__label">{{ $t('banking.bank_type') }}</label>
            <AccountSelect
              :data="account"
              field="type"
              :accounts="accounts"
            />
            <span class="payment-field__error">{{ errors.account }}</span>
          </div>

          <button
            type="button"
            class="payment-submit-btn"
            :disabled="isConfirm"
            @click="updateBankInfo()"
          >
            <Loading
              v-if="isConfirm"
              color="#1a1a1a"
              size="24"
            />
            <span v-else>{{ $t('banking.submit') }}</span>
          </button>

          <div class="payment-info-note">
            <h3 class="payment-info-note__title">{{ $t('banking.note') }}</h3>
            <p class="payment-info-note__text">{{ $t('banking.note_content') }}</p>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      error: null,
      accounts: [
        {
          name: 'KBZ pay',
          id: 'KBZ pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'Wave pay',
          id: 'Wave pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/wavepay.png',
        },
      ],
      account: {},
      errors: {},
      isConfirm: false,
    };
  },
  methods: {
    async fetchBankInfo() {
      try {
        const res = await axios.get('/user_bank', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.account = res.data.data || {};
      } catch (error) {
        console.log(error);
      }
    },
    ...mapActions(['fetchUser']),
    async updateBankInfo() {
      try {
        this.error = null;
        if (!this.account.type) {
          this.error = this.$store.state.language === 'en'
            ? 'Please pick account type'
            : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
          return false;
        }
        if (!this.account.account_number) {
          this.error = this.$store.state.language === 'en'
            ? 'Please enter account number'
            : 'အကောင့်နံပါတ် ထည့်သွင်းပေးပါ။';
          return false;
        }
        if (!this.account.name) {
          this.error = this.$store.state.language === 'en'
            ? 'Please enter bank username'
            : 'Please enter bank username';
          return false;
        }

        this.isConfirm = true;

        await axios.put('/user_bank', this.account, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.error = null;
        Toast.success('Success');
        this.isConfirm = false;
      } catch (err) {
        this.error = err.response?.data || 'Request failed';
        this.isConfirm = false;
      }
      return true;
    },
  },
  async mounted() {
    await this.fetchBankInfo();
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
  },
};
</script>
